<template>
    <section class="slice barometer-home__prices">
        <div class="slice-content barometer-home__prices__columns">
            <BarometerHomePricesSummary />
            <ul class="barometer-home__prices__items">
                <li v-for="price in prices" :key="price.id">
                    <BarometerHomePricesItem :data="price" />
                </li>
            </ul>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {useTranslation} from '#imports';
    import {BAROMETER_HOME} from '~/keys';
    import BarometerHomePricesItem from './BarometerHomePricesItem.vue';
    import BarometerHomePricesSummary from './BarometerHomePricesSummary.vue';

    const {generalBarometer} = inject(BAROMETER_HOME)!;

    const pictoAllowList = ['family-developers_datascientists'];
    const prices = generalBarometer.familyAndPrices;
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .barometer-home__prices {
        background-color: var(--joy-color-neutral-20);

        &__columns {
            @include mq.screen_md(min) {
                display: flex;
                gap: var(--joy-core-spacing-9);
            }
        }

        &__summary {
            margin-bottom: var(--joy-core-spacing-9);

            @include mq.screen_md(min) {
                width: 480px;
                flex: none;
            }
        }

        &__items {
            display: flex;
            flex-wrap: wrap;
            gap: var(--joy-core-spacing-4);
            list-style: none;

            > li {
                flex: 1 1 190px;
            }
        }
    }
</style>
